<template>
  <div class="home-main-left-login">
    <div class="login-form">
      <div class="form-item">
        <el-input type="text" v-model="loginForm.loginId" placeholder="请输入证件号码" @keyup.enter.native="submitLogin" v-focus-caller/>
      </div>
      <div class="form-item">
        <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" @keyup.enter.native="submitLogin" v-focus-caller/>
      </div>
      <div class="form-item append" v-if="needAuthCode || needSendSms">
        <el-input type="text" v-model="loginForm.authCode" placeholder="请输入图形验证码" v-focus-caller/>
        <div class="form-append">
          <div class="auth-img" :style="{'background-image': 'url(' + getContextPath(authImg.src + '?' + authImg.stamp) + ')'}" title="点击更换验证码" @click="reloadAuthImg"/>
        </div>
      </div>
      <div class="form-item append" v-if="needSendSms">
        <el-input type="text" v-model="loginForm.smsCode" :placeholder="`请输入${loginForm.sendType === 'SMS' ? '短信' : '邮箱'}验证码`" @keyup.enter.native="submitLogin" v-focus-caller/>
        <div class="form-append">
          <el-button type="info" class="send-verification-btn" :disabled="loginVerification.committing || loginVerification.delay > 0" @click="sendLoginVerification">{{loginVerification.delay > 0 ? loginVerification.delay + '秒后重发' : '获取验证码'}}</el-button>
        </div>
      </div>
    </div>
    <div class="bottom-menu clearfix">
      <div class="forget-password">
        <router-link to="/forgetPassword">忘记密码？</router-link>
      </div>
      <div class="twoFA" v-if="needSendSms">
        <el-tooltip content="短信验证" v-if="loginForm.sendType === 'EMAIL'">
          <span  @click.stop="changeSendType('SMS')"><i class="el-icon-mobile-phone"></i></span>
        </el-tooltip>
        <el-tooltip content="邮箱验证" v-if="loginForm.sendType === 'SMS'">
          <span  @click.stop="changeSendType('EMAIL')"><i class="el-icon-message"></i></span>
        </el-tooltip>
      </div>
    </div>
    <div class="btn-group">
      <el-button type="primary" class="submit-login-btn login-register-button-style" :disabled="loginForm.committing" @click="submitLogin">{{loginForm.committing ? '登录中...' : '登录'}}</el-button>
    </div>
  </div>
</template>

<script>
import support from '../../../mixins/support'
import focusCaller from '../../../directives/focusCaller'
import {mapActions} from 'vuex'

export default {
  name: 'HomeMainLeftLogin',
  mixins: [support],
  directives: {focusCaller},
  inject: ['checkPasswordExpirationInfo'],
  data () {
    return {
      authImg: {
        src: '/index/authImg/homeIndexLogin',
        stamp: new Date().getTime()
      },
      loginForm: {
        loginId: '',
        password: '',
        authCode: '',
        sendType: 'SMS',
        smsCode: '',
        committing: false
      },
      needSendSms: false,
      needAuthCode: false,
      loginVerification: {
        delay: 0,
        timer: null,
        committing: false
      }
    }
  },
  methods: {
    ...mapActions(['loadUserAuthorize']),
    reloadAuthImg () {
      this.authImg.stamp = new Date().getTime()
    },
    loadLoginData () {
      this.$ajax({
        url: '/index/homeIndex/loginData',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.needAuthCode = response.data['needAuthCode'] || false
          this.needSendSms = response.data['needSendSms'] || false
        }
      })
    },
    refreshSmsSendDelay () {
      if (this.loginVerification.delay > 0) {
        this.loginVerification.timer = setTimeout(() => {
          this.loginVerification.delay--
          this.refreshSmsSendDelay()
        }, 1000)
      }
    },
    sendLoginVerification () {
      let loginId = this.loginForm.loginId
      if (!loginId) {
        this.$message.error('请输入证件号码')
        this.$emit('focus', 'loginForm.loginId')
        return
      }
      let password = this.loginForm.password
      if (!password) {
        this.$message.error('请输入密码')
        this.$emit('focus', 'loginForm.password')
        return
      }
      let authCode = this.loginForm.authCode
      if (!authCode) {
        this.$message.error('请输入图形验证码')
        this.$emit('focus', 'loginForm.authCode')
        return
      }
      this.loginVerification.committing = true
      this.$ajax({
        url: '/index/homeIndex/sendLoginVerification',
        method: 'post',
        data: this.$qs.stringify({
          loginId: loginId,
          password: this.$md5(password),
          authCode: authCode,
          sendType: this.loginForm.sendType
        })
      }).then(response => {
        // 成功返回则要刷新验证码
        this.reloadAuthImg()
        // 处理返回结果
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              // 延时处理
              let sendDelay = response.data['sendDelay']
              if (typeof sendDelay === 'number') {
                this.loginVerification.delay = sendDelay
              }
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('获取验证码请求发送失败')
      }).finally(() => {
        this.loginVerification.committing = false
      })
    },
    changeSendType (val) {
      this.loginForm.smsCode = ''
      this.loginForm.sendType = val
    },
    submitLogin () {
      let loginId = this.loginForm.loginId
      if (!loginId) {
        this.$message.error('请输入证件号码')
        this.$emit('focus', 'loginForm.loginId')
        return
      }
      let password = this.loginForm.password
      if (!password) {
        this.$message.error('请输入密码')
        this.$emit('focus', 'loginForm.password')
        return
      }
      let authCode
      if (this.needAuthCode) {
        authCode = this.loginForm.authCode
        if (!authCode) {
          this.$message.error('请输入图形验证码')
          this.$emit('focus', 'loginForm.authCode')
          return
        }
      }
      let smsCode
      if (this.needSendSms) {
        smsCode = this.loginForm.smsCode
        if (!smsCode) {
          this.$message.error('请输入短信验证码')
          this.$emit('focus', 'loginForm.smsCode')
          return
        }
      }
      this.loginForm.committing = true
      this.$ajax({
        url: '/index/homeIndexLogin',
        method: 'post',
        data: this.$qs.stringify({
          loginId: loginId,
          password: this.$md5(password),
          authCode: authCode || '',
          smsCode: smsCode || '',
          sendType: this.loginForm.sendType
        })
      }).then(response => {
        // 成功返回则要刷新验证码
        this.reloadAuthImg()
        // 处理返回结果
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              // 登录成功获取授权信息
              this.loadUserAuthorize().then(result => {
                this.checkPasswordExpirationInfo(result)
                if (this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect)
                }
              }, err => {
                this.$message.error('授权失败：' + err.message)
              })
              break
            }
            default: {
              this.$message.error(response.data['message'])
              // 下次是否需要提供验证码
              this.needAuthCode = response.data['needAuthCode'] || false
              break
            }
          }
        }
      }, () => {
        this.$message.error('用户登录信息提交失败')
      }).finally(() => {
        this.loginForm.committing = false
      })
    }
  },
  created () {
    this.loadLoginData()
  },
  watch: {
    'loginVerification.delay': function (newVal, oldVal) {
      if (oldVal <= 0 && newVal > 0) {
        clearTimeout(this.loginVerification.timer)
        this.refreshSmsSendDelay()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../styles/theme";
.home-main-left-login {
  padding-top: 40px;
  &>.login-form {
    &>.form-item {
      position: relative;
      &+.form-item {
        margin-top: 40px;
      }
      &.append {
        padding-right: 130px;
        &>.form-append {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 40px;
          &>.auth-img {
            position: relative;
            width: 100%;
            height: 40px;
            background: center no-repeat;
            border-radius: 3px;
            background-size: contain;
            box-sizing: border-box;
            cursor: pointer;
            overflow: hidden;
          }
          .send-verification-btn {
            color: $default-text-color;
            width: 100%;
            font-size: 14px;
            transition: none;
            background-color: $default-button-background-color;
            border-color: $default-button-background-color;
            &:active {
              background-color: darken($default-button-background-color, 5);
              border-color: darken($default-button-background-color, 5);
            }
          }
        }
      }
      &>.el-input {
        width: 100%;
        &>.el-input__inner {
          height: 40px;
          line-height: 18px;
          padding: 9px 15px;
          border: none !important;
          background-color: rgba(242, 242, 242, 0.6)
        }
      }
    }
  }
  &>.bottom-menu {
    margin-top: 18px;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 20px;
    &>.forget-password {
      &>a {
        font-size: 14px;
        color: $theme-primary-color;
        font-weight: bold;
      }
    }
    &>.twoFA {
      font-size: 18px;
      font-weight: 800;
      cursor: pointer;
      color: $theme-primary-color;
      background-color: #EBEEF5;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &>.btn-group {
    margin-top: 214px;
    padding-bottom: 30px;
    &>.el-button {
      height: 40px;
      width: 100%;
      &.submit-login-btn {
        font-size: 16px;
        letter-spacing: 3px;
      }
    }
  }
}
@media (max-width: 1052px) and (min-width: 641px) {
  .home-main-left-login {
    &>.login-form {
      &>.form-item {
        &.append {
          padding-right: 94px;
          &>.form-append {
            width: 84px;
          }
        }
      }
    }
  }
}
@media (max-width: 640px) {
  .home-main-left-login {
    &>.btn-group {
      margin-top: 64px;
      padding-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeMainLeftLogin.vue